<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Cargar de descuentos</h1>
        </div>
        <div class="ctn_general">
            <div class="tabla_ctn subir_csv">
                <div class="tabla_filtros">
                    <div class="tfiltros_col lg left">
                        <p>Cargar CSV de descuentos</p>
                    </div>
                    <div class="tfiltros_col xs right">
                        <a @click="downloadTemplate" style="margin-left: auto;" href="javascript:void(0)"
                           download="download"
                           class="descargar_archivo mdi mdi-arrow-collapse-down tool">
                            <span class="tooltip top left">Descargar plantilla CSV</span>
                        </a>
                    </div>
                </div>
                <div class="subir_producto_ctn">
                    <div class="drag_ctn_estados">
                        <div class="grupo_campos tipo_checkbox">
                            <input type="checkbox" id="cb_refreshall" v-model="refreshAll">
                            <label for="cb_refreshall">Reemplazar descuentos existentes. </label>
                        </div>
                        <form action="">
                            <c-input type="select" :field="$v.company" id="company"
                                     classes="grupo_campos tipo_text" label="Empresa *" :items="companies"/>
                            <div class="box_drag" v-if="company">
                                <file-pond
                                    name="files"
                                    ref="pond"
                                    label-idle="Suelta tu archivo aquí..."
                                    v-bind:allow-multiple="false"
                                    accepted-file-types="application/vnd.ms-excel, application/csv, text/csv, .csv"
                                    labelFileProcessingComplete='Carga completada'
                                    labelFileProcessing='Subiendo'
                                    labelTapToCancel='Presiona para cancelar'
                                    labelTapToRetry='Presiona para reintentar'
                                    labelFileProcessingError='Error al cargar archivo'
                                    :server="server"
                                    v-bind:files="myFiles"/>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import {AUTH_TOKEN} from "../../util/constants";
    import {companies} from "../../util/options";
    import ClientService from "../../services/ClientService";
    import {required} from 'vuelidate/lib/validators'
    import {getFileName, loading} from '../../util/util'
    import fileDownload from 'js-file-download';
    import alert from '../../util/alert'
    import vueFilePond from 'vue-filepond';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import CInput from '../common/CInput.vue'

    const FilePond = vueFilePond(FilePondPluginFileValidateType);

    export default {
        components: {FilePond, CInput},
        data() {
            return {
                myFiles: [],
                refreshAll: false,
                companies,
                company: null,
                server: {},
                process: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem(AUTH_TOKEN)
                    },
                    onload: () => {
                        this.refreshAll = false;
                        this.company = null;
                        alert.success("Carga completada.");

                    },
                }
            }
        },
        validations: {
            company: {required},
        },
        watch: {
            refreshAll: function () {
                const self = this;
                self.server = {
                    url: `${process.env.SVC_URL}/client/batch/disc?refreshAll=${self.refreshAll}&&company=${self.company}`,
                    process: self.process
                }
            },
            company: function () {
                const self = this;
                self.server = {
                    url: `${process.env.SVC_URL}/client/batch/disc?refreshAll=${self.refreshAll}&&company=${self.company}`,
                    process: self.process
                }
            }
        },
        methods: {
            downloadTemplate() {
                loading(true);
                ClientService.downloadDiscTemplate().then(response => {
                    fileDownload(response.data, getFileName(response));
                }).catch((err) => {
                    console.error(err);
                    alert.error("Error al descargar plantilla de CSV para carga de descuentos.");
                }).finally(() => {
                    loading(false);
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/clients/ClientDiscLoad.vue